import React from 'react';
import { toast } from 'react-toastify';
import InfoBody from './InfoBody';
import ErrorBody from './ErrorBody';

export const info = msg => toast.info(<InfoBody msg={msg} />);
export const error = msg => toast.error(<ErrorBody msg={msg} />);
const dismiss = () => toast.dismiss();

export default { info, error, dismiss };
